import PaymentDetailsServices from './PaymentDetailsServices';
import PaymentDetailsServicesMock from './PaymentDetailsServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? PaymentDetailsServicesMock : PaymentDetailsServices;
